<template>
    <div class="home_wrap">
        <div style="height: 44px;"></div>
        <!-- <div class="red_top_bg m-flex m-f-between m-pd1">
            <div @click="$router.push('/index')">
                <img style="height: 40px;width:auto;" :src="logo" alt="" />
            </div>
            <div class="h3" @click="$router.push('/menu')">
                <img src="@/assets/images/menus.png" alt="" />
            </div>
        </div> -->
        <div class="red_top_bg">
          <div class="back_left" @click="$router.back()"></div>
          <div class="big_tit">{{ $t('资讯详情') }}</div>
        </div>
        <div class="top_box" v-if="info != null">
            <div class="boxs">
                <div class="t1">
                   {{ info.time }}
                </div>
                <div class="title">
                   {{ info.title }}
                </div>
                <div class="image">
                    <img :src="info.img_url" alt="">
                </div>
            </div>
        </div>
        <template v-if="info != null && info.content != ''">
            <div class="texts" v-html="info.content">
            </div>
        </template>
        <div class="footers">
            <div class="list">
                <a target="_blank" href="https://x.com/intent/post?text=Warner%20Bros.%20Discovery%20Announces%20Cohort%20for%202025%20Accelerator%20Program&url=https%3A%2F%2Fwww.wbd.com%2Fnews%2Fwarner-bros-discovery-announces-cohort-2025-accelerator-program">
                  <span class="iconfont icon-x"></span>
                </a>
                <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.wbd.com%2Fnews%2Fwarner-bros-discovery-announces-cohort-2025-accelerator-program&t=Warner+Bros.+Discovery+Announces+Cohort+for+2025+Accelerator+Program">
                  <span class="iconfont icon-f" style="font-size: 30px;"></span>
                </a>
                <a target="_blank" href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%253A%252F%252Fwww.wbd.com%252Fnews%252Fwarner-bros-discovery-announces-cohort-2025-accelerator-program%26title%3DWarner%2BBros.%2BDiscovery%2BAnnounces%2BCohort%2Bfor%2B2025%2BAccelerator%2BProgram">
                  <span class="iconfont icon-in" style="font-size: 30px;"></span>
                </a>
                <a target="_blank" href="https://www.pinterest.com/pin/create/button/?url=https%3A%2F%2Fwww.wbd.com%2Fnews%2Fwarner-bros-discovery-announces-cohort-2025-accelerator-program&description=Warner+Bros.+Discovery+Announces+Cohort+for+2025+Accelerator+Program">
                  <span class="iconfont icon-uniF0D3"></span>
                </a>
                <a target="_blank" href="https://www.tumblr.com/login?redirect_to=https%3A%2F%2Fwww.tumblr.com%2Fwidgets%2Fshare%2Ftool%3FshareSource%3Dlegacy%26canonicalUrl%3Dhttps%253A%252F%252Fwww.wbd.com%252Fnews%252Fwarner-bros-discovery-announces-cohort-2025-accelerator-program%26title%3DWarner%2BBros.%2BDiscovery%2BAnnounces%2BCohort%2Bfor%2B2025%2BAccelerator%2BProgram">
                  <span class="iconfont icon-uniF174"></span>
                </a>
            </div>
            <div class="bottoms">
              <div class="lists">
                <a target="_blank" href="https://x.com/wbd">
                  <span class="iconfont icon-x"></span>
                </a>
                <a target="_blank" href="https://www.instagram.com/wbd">
                  <span class="iconfont icon-a-345_F16D__instagram" style="font-size: 16px;"></span>
                </a>
                <a target="_blank" href="https://www.facebook.com/WBD">
                  <span class="iconfont icon-f" style="font-size: 16px;"></span>
                </a>
                <a target="_blank" href="https://www.youtube.com/wbd">
                  <span class="iconfont icon-a-rongqi259" style="font-size: 26px;"></span>
                </a>
                <a target="_blank" href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFkcZKNCaza9gAAAZdFW9JYFIVQS9vvyLJlchqGVZB2IVovjxQ2jM46QjbZO9aik1mUiTu-haBhKqCJHQKNhV7L3J7w3519BouuKR9KhIlg1nGnzEhL6agqqvXyFwIqwlM3nyU=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fwarner-bros-discovery">
                  <span class="iconfont icon-in" style="font-size: 18px;"></span>
                </a>
              </div>
            </div>
            <footers></footers>
        </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import Fetch from "../../utils/fetch";
  import footers from '@/components/bsFooter.vue'
  export default {
    name: "journalism",
    components: {
      footers
    },
    data() {
      return {
        logo:localStorage.getItem('logo') || require('@/assets/images/logo.png'),
        info:null
      };
    },
    created() {
      this.$parent.footer('journalism');
    },
    mounted() {
      this.start()
    },
    methods: {
      start() {
        Fetch('/news/getNewsDetail', {
          id: this.$router.history.current.params.code
        }).then(res => {
           this.info = res.data
        })
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
.red_top_bg {
	position: fixed;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10;
}
  .home_wrap {
    width: 100%;
    height: fit-content;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .top_box {
    padding: 34px 0px;
    width: 100%;
    height: fit-content;
    background: #038566;
    .boxs {
      width: 90%;
      margin: 0 auto;
      height: fit-content;
      .t1 {
        font-size: 12px;
        font-weight: 900;
        color: #10EAD5;
        margin-bottom: 30px;
      }
      .title {
        font-family: "Beatrice Bold",Arial,Helvetica,sans-serif;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: normal;         /* 依据语言规则在单词间换行 */
        white-space: normal;        /* 合并多余空格，在换行符和容器边缘处换行 */
        font-size: 24px;
        color: #fff;
        display: block;
        font-weight: 900;
        line-height: 30px;
        padding-bottom: 20px;
      }
      .image {
        width: 100%;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .texts {
    width: 90%;
    height: fit-content;
    margin: 50px auto;
    line-height: 30px;
    font-size: 18px;
    color: #04006c;
    div,p {
        font-family: "Beatrice Bold",Arial,Helvetica,sans-serif;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: normal;         /* 依据语言规则在单词间换行 */
        white-space: normal;   
    }
  }
  .footers {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: auto;
    .list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 25px 0px 45px 0px;
      a {
        display: block;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        margin: 0px 10px;
        border-radius: 6px;
        span {
          font-size: 36px;
          color: #04006C;
        }
      }
    }
    .bottoms {
      width: 100%;
      height: fit-content;
      background: #04006C;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .lists {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 25px 20px 45px 20px;
        a {
          display: flex;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          margin: 0px 10px;
          border-radius: 6px;
          span {
            font-size: 20px;
            color: #fff;
          }
        }
      }
      .logo {
        width: 220px;
        height: fit-content;
        padding-bottom: 30px;
        img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top:10px;
      padding-bottom: 30px;
      background: #04006C;
      p {
        width: 100%;
        font-size: 10px;
        margin: 5px auto;
        text-align: center;
        color: #fff;
      }
    }
  }
  </style>
  